<template>
    <group-card title="Insurances" icon="beach_access">
      <div
        class="md-layout input-layout"
        v-for="insurance in insurances"
        :key="insurance.type"
        v-if="insurances!=null"
      >
        <md-checkbox
          type="checkbox"
          class="md-layout-item md-small-size-5 md-size-5"
          v-model="insurance.enabled"
        />
        <p class="md-layout-item md-small-size-5 md-size-5">
          <strong>{{ insurance.type }}</strong>
        </p>
        <validated-autocomplete-input
          class="md-layout-item md-small-size-12.5 md-size-12.5"
          v-model="insurance.insurer"
          :options="options.insurance_provider"
          label="Insurer" :disabled="disabled"
          force
        />
        <validated-text-input
          class="md-layout-item md-small-size-12.5 md-size-12.5"
          v-model="insurance.policy"
          label="Product"
          :disabled="disabled">
        </validated-text-input>
        <validated-input
          type="TERM"
          class="md-layout-item md-small-size-12.5 md-size-12.5"
          v-model="insurance.term"
          label="Cover Term"
          :disabled="disabled"
        />
        <validated-input 
          type="REQUIRED_DATE"
          class="md-layout-item md-small-size-12.5 md-size-12.5"
          v-model="insurance.policy_end_date"
          label="Policy End Date"
          :disabled="disabled"
        />
        <validated-input type="CURRENCY"
          class="md-layout-item md-small-size-12.5 md-size-12.5"
          v-model="insurance.premium"
          label="Premium"
          :disabled="disabled"
        />
        <validated-input type="CURRENCY"
          class="md-layout-item md-small-size-12.5 md-size-12.5"
          v-model="insurance.income"
          label="Income"
          :disabled="disabled"
        />
        <validated-autocomplete-input
          class="md-layout-item md-small-size-10 md-size-10"
          label="Frequency"
          v-model="insurance.frequency"
          :options="filteredPaymentFrequencies"
          force
        />
        <validated-text-input
          class="md-layout-item md-small-size-12.5 md-size-12.5"
          v-model="insurance.policy_number"
          label="Policy Number"
          :disabled="disabled"
          :required="insurance.enabled == true"
        />
        <md-checkbox
          type="checkbox"
          class="md-layout-item md-small-size-10 md-size-10"
          v-model="insurance.include_in_naf"
          :disabled="disabled"
        >
          Include in NAF
        </md-checkbox>
      </div>
    </group-card>
</template>
<script>
import ValidatedInputs from '@/components/ValidatedInput';
import {mapGetters} from "vuex";
import {GroupCard} from "@/components";
import filters from "./utils/filters";

export default {
    components: {
        GroupCard,
    ...ValidatedInputs,
    },
    computed: {
      ...mapGetters([
        'options',
        'application'
      ]),
      filteredPaymentFrequencies() {
        return this.options.payment_frequency_options.filter(option =>
          option === 'Monthly' || option === 'Yearly'
        );
      },
    },
  methods: {
    // make all filters available as methods
    ...filters,
  },
  props: ['insurances', 'disabled'],
  filters: {
    // make all filters available as filters
    ...filters
  },
  async beforeCreate() {
    const params = {
      types: [
        'insurance_provider',
        'payment_frequency_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>
